import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AvailableFacadeCustomSlotSchema, GrooveTypeEnum } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable, map } from 'rxjs';
import { CuttingCustomHoleSchema } from '../../models/cutting/cutting-custom-hole-schema.model';
import { CuttingFastenersSet } from '../../models/cutting/cutting-fasteners-set.model';
import { Milling } from '../../models/cutting/cutting-panel-outline.model';
import { CuttingPanelSlot } from '../../models/cutting/cutting-panel-slot.model';
import { FacadeAvailableSlot } from '../../models/cutting/facade-available-slot.model';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

@Injectable()
export class FacadeSettingsDataService {
  
  constructor(private http: HttpClient, ) {}

  getMillingsForClient(): Observable<Milling[]> {
    return this.http.get<Milling[]>(ApiLinks.millingsForClient);
  }

  public getAvailableHoleSchema(): Observable<CuttingCustomHoleSchema[]> {
    return this.http
      .get<CuttingCustomHoleSchema[]>(ApiLinks.orderFacade + '/available-custom-holes')
      .pipe(map(res => res.map(s => _.merge(new CuttingCustomHoleSchema(), s))));
  }

  public getAvailableFastenersSetSchema(): Observable<CuttingFastenersSet[]> {
    return this.http
      .get<CuttingFastenersSet[]>(ApiLinks.orderFacade + '/available-fasteners-sets')
      .pipe(map(res => res.map(s => _.merge(new CuttingFastenersSet(), s))));
  }

  public getFacadeSlots(): Observable<FacadeAvailableSlot[]> {
    return this.http.get<FacadeAvailableSlot[]>(ApiLinks.orderFacade + '/facade-slots');
  }

  public getAvailableCustomSlotsSchemas = (grooveType: GrooveTypeEnum): Observable<AvailableFacadeCustomSlotSchema[]> => {
    let httpParams: HttpParams = new HttpParams();

    if (!_.isNull(grooveType)) {
      httpParams = httpParams.append('grooveType', grooveType.toString());
    }

    return this.http.get<AvailableFacadeCustomSlotSchema[]>(
      ApiLinks.orderFacade + '/available-custom-slots-schemas',
      { params: httpParams }
    );
  };

  public postCustomSlotsData = (slot: CuttingPanelSlot): Observable<number> => {
    return this.http.post<number>(ApiLinks.orderFacade + '/save-custom-slot', slot);
  };

  public deleteCustomSlot = (id: number): Observable<void> => {
    return this.http.delete<void>(ApiLinks.orderFacade + '/delete-custom-slot/' + id);
  };
}
